/**
 * File Upload Constants
 * 
 * Defines supported file types and formats for photo uploads
 * in the admin application.
 */

export const SUPPORTED_IMAGE_TYPES = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/jpg': ['.jpg'],  // Non-standard but commonly returned by some image pickers
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
  'image/heic': ['.heic'],
  'image/heif': ['.heif'],
} as const;

export const SUPPORTED_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.heic', '.heif'];
export const SUPPORTED_IMAGE_MIME_TYPES = Object.keys(SUPPORTED_IMAGE_TYPES);
export const SUPPORTED_FORMATS_DISPLAY = 'JPEG, PNG, GIF, WebP, HEIC';

/**
 * Validates if a file type is supported for image uploads
 * @param mimeType - The MIME type of the file (e.g., 'image/jpeg')
 * @returns true if the file type is supported
 */
export const isValidImageMimeType = (mimeType: string): boolean => {
  return SUPPORTED_IMAGE_MIME_TYPES.includes(mimeType);
};

/**
 * Validates if a file extension is supported for image uploads
 * @param extension - The file extension (e.g., '.jpg' or 'jpg')
 * @returns true if the extension is supported
 */
export const isValidImageExtension = (extension: string): boolean => {
  const normalizedExt = extension.toLowerCase().startsWith('.') 
    ? extension.toLowerCase() 
    : `.${extension.toLowerCase()}`;
  return SUPPORTED_IMAGE_EXTENSIONS.includes(normalizedExt);
};

